import script from "./UserRemoveIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRemoveIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__